module.exports = __webpack_public_path__ + "img/pc_leaf_L.5dcdef3.webp";